import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import bowser from "bowser";
import CopiarURL from "../hooks/CopiarUrl";

const Home = ({ setAnim }) => {
  const navigate = useNavigate();
  const [actualBrowser, setActualBrowser] = useState();
  const [isCopied, setIsCopied] = useState(false);
  const [isChorme, setIsChorme] = useState(true);

  useEffect(() => {
    detectBrowser();
  }, []);

  const detectBrowser = () => {
    const browser = bowser.getParser(window.navigator.userAgent);
    setActualBrowser(browser.getBrowserName());

    if (actualBrowser === "Chrome") {
      setIsChorme(true);
    } else {
      setIsChorme(false);
    }
  };

  const changePage = () => {
    const anims_left = document.querySelector(".anim_slider");
    anims_left.classList.remove("animate__bounceInDown");
    anims_left.classList.add("animate__bounceOutDown");
    setAnim(true);
    setTimeout(() => {
      setAnim(false);
      navigate("/formulario");
    }, 1000);
  };

  return (
    <div className="home">
      <div className="home_container containerAll">
        <div className="anim_slider animate__animated animate__bounceInDown">
          <div
            className={`content_info ${
              actualBrowser === "Chrome" ? "variation_home" : ""
            }`}
          >
            <h1>GALERÍA MUSICALIZADA</h1>
            <p>Crea tu video personalizado de Canti Rondas.</p>
          </div>

          {actualBrowser === "Chrome" ? (
            <section>
              <div className="content_buttons">
                <div className="button_one">
                  <button onClick={changePage}>Empezar</button>
                </div>
              </div>

              <div className="button_two">
                <button
                  onClick={() => (window.location.href = "https://cantirondas.com/")}
                >
                  Ir a cantirondas
                </button>
              </div>

              <div className="button_two pb">
                <button onClick={() => navigate("/galeria")}>Ir a Galería</button>
              </div>
            </section>
          ) : (
            <section className="erro_chorme">
              <div className="container_chorme">
                <img src="/assets/error_chorme/1.png" alt="" />
                <div className="info_error">
                  <h1>
                    nos vemos <br /> en chrome
                  </h1>
                  <p>¡Usa Google Chrome para una experiencia inolvidable!</p>
                  <div className="copy">
                    <CopiarURL setIsCopied={setIsCopied} />
                    {!isCopied ? <p>Copiar link</p> : <p>Link copiado</p>}
                  </div>
                </div>
              </div>
            </section>
          )}
        </div>
      </div>
    </div>
  );
};

export default Home;
